import { render, staticRenderFns } from "./resume-cover-letter.vue?vue&type=template&id=0be922e6"
import script from "./resume-cover-letter.vue?vue&type=script&lang=js"
export * from "./resume-cover-letter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports